import { forwardRef, useEffect, useImperativeHandle, useState,
  useContext,
  useRef,
} from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '../../IconFont';
import GetAddress from './GetAddress'; // 点标记
import Ruler from './Ruler'; // 测距
import Satellite from './Satellite'; // 卫星图插件
import Share from './Share'; // 分享
import Explain from './Explain'; // 说明文档
import HeatMapTool from './HeatMapTool'; // 人口热力
import RulerShortCutPanel from './RulerShortCutPanel'; // 工具箱快捷面板
import MapHelpfulContext from '@/common/components/AMap/MapHelpfulContext';
// import { CaretDownOutlined } from '@ant-design/icons';
import { tenantCheck } from '@/common/api/common';
import { useMethods } from '@lhb/hook';
import { isFunction } from '@lhb/func';
import { MapView } from '@/views/youth/pages/map/ts-config';
import CheckInFieldA, { QuitFootPrint } from './CheckInFieldA';
import { useBigdataFn } from '@/common/utils/bigdata';
import { mergeToolBoxType, ToolBoxChangeOperationEnum, ToolBoxChangeOperationObj, ToolBoxType, useToolBoxList } from './ts-config';
import V2Message from '../../Others/V2Hint/V2Message';
import { LngLat } from '../../Map/V2AMap';


const ToolBox:any = forwardRef<any, any>(
  (
    {
      _mapIns,
      clearClickEvent,
      addClickEvent,
      URLParamsRef,
      share = false,
      explain = false,
      getAddress = true,
      heartMap = true, // 热力开关
      ruler = true,
      satellite = true,
      checkInFieldA = false, // 打靶任务
      targetPunchInAlias = '打卡', // 打靶任务别名
      children,
      extraCityInfo, // 通过外部传递相关city参数去获取热力信息
      externalStatus, // 初始化控制热力图开关
      // isShowInCountry, // 是否在全国状态下显示热力图
      // isCheckInsideMapOperate, // 工具箱内部是否已选中地图操作按钮，用于与该组件外的地图操作功能互斥（目前有标记、测距）
      setIsCheckInsideMapOperate, // 工具箱内部是否已选中地图操作按钮，用于与该组件外的地图操作功能互斥（目前有标记、测距）
      isCheckOutsideMapOperate, // 外部是否选中了地图操作按钮
      setIsCheckOutsideMapOperate, //
      needHeatMapPermission = false, // 热力图接口是否需要数据权限，默认不需要（目前网规场景需要）
      setIsOpenHeatMap, // 是否打开热力图开关
      topLevel, // 热力图的可显示的最高级别-对应COUNTRY_LEVEL、PROVINCE_LEVEL...
      toolBoxWrapperStyle, // 样式
      beforeIcon, // 工具箱icon
      afterIcon, // 箭头icon
      getAddressEventId, // 标记点击埋点id
      rulerEventId, // 测距点击埋点id
      contentStyle, // 内容样式
      closeOutPanel, // 关闭外部快捷面板
      satelliteEventId, // 卫星点击埋点id
      finallyShowStatus, // 同步组件内部的面板显示状态
      panelContentStyleOfOut, // 面板内容样式（从外部传进来）
      trigger = 'click',
      floatDirection = 'right', // 定位方向
      // addBusinessEventId,
      inDrawToolRef,
      isAutoFitView,
      mapView,
      isFull,
      onRefreshCheckInData,
      // toolChange, // 工具库功能开启时回调，沙盘处需要再开启打靶、测绘、标记时触发一个禁用所有marker mass的功能。可以使用此回调
      onClickBoxHandle,
      onToolBoxEnterHandle
    },
    ref
  ) => {
    const toolBoxList = useToolBoxList();
    const getAddressRef: any = useRef();
    const bigdataFn = useBigdataFn(); // 使用 Hook
    const inToolBoxRef: any = useRef(false); // 工具箱hover状态
    const inDropDownBoxRef: any = useRef(false); // 工具箱下拉框元素hover状态
    const checkInFieldARef = useRef<any>(null);
    const rulerRef = useRef<any>(null);
    const [selected, setSelected] = useState<number>(0);
    // 目前用在工具箱中的标记和测距的标记，两者互斥，选择了其中一种操作，另外的操作状态就清除掉
    const [targetOperation, setTargetOperation] = useState<string>(''); // 当前操作
    const [isShowPanel, setIsShowPanel] = useState<boolean>(false); // 是否显示测距快捷面板
    const [isShowBox, setIsShowBox] = useState<boolean>(false);
    const [rulerType, setRulerType] = useState<number>(0); // 测距类型 1-直线 2-步行 3-驾车 4-骑行
    const [rulering, setRulering] = useState<boolean>(false);
    const [handleHeatMap, setHandleHeatMap] = useState<boolean>(false);
    const helpfulContext: any = useContext(MapHelpfulContext);
    /** 当以下工具打开时允许继续点击工具箱的列表 */
    const allowClickToolBoxList: ToolBoxType[] = [mergeToolBoxType.DOT_MARK, mergeToolBoxType.SATELLITE];

    // console.log('targetOperation', targetOperation, selected);
    // const toolChangeValueCache = useRef<any>({
    //   ruler: false, // 是否在使用测绘功能
    //   checkInFieldA: false, // 是否在使用打靶功能
    //   doMark: false, // 是否在使用标记功能
    //   drawToolType: false, // 是否在使用圈选功能
    // });

    // console.log(addBusinessEventId);

    useEffect(() => {
      const { stateEvent } = helpfulContext;
      if (!stateEvent) return;
      if (!rulerType) {
        stateEvent((state) => ({
          ...state,
          toolBox: {
            ...state.toolBox,
            stadiometry: null, // 测距
          },
        }));
        return;
      };

      stateEvent((state) => ({
        ...state,
        toolBox: {
          ...state.toolBox,
          stadiometry: {
            value: rulerType
          }, // 测距
        },
      }));
    }, [rulerType, helpfulContext?.stateEvent]);

    useEffect(() => {
      const { stateEvent } = helpfulContext || {};
      if (stateEvent && targetOperation === 'dotMark') { // 打点
        stateEvent((state) => ({
          ...state,
          toolBox: {
            ...state.toolBox,
            makePoint: {
              value: true
            }
          },
        }));
        return;
      }

      stateEvent && stateEvent((state) => ({
        ...state,
        toolBox: {
          ...state.toolBox,
          makePoint: null
        },
      }));
    }, [targetOperation, helpfulContext?.stateEvent]);

    // 监听targetOperation,并传到context中
    useEffect(() => {
      helpfulContext?.stateEvent?.((state) => ({
        ...state,
        toolBox: {
          ...state.toolBox,
          selectedType: targetOperation
        }
      }));
    }, [targetOperation]);

    useEffect(() => {
      // 组件销毁时，清除context中的targetOperation
      return () => {
        helpfulContext?.stateEvent?.((state) => ({
          ...state,
          toolBox: {
            ...state.toolBox,
            selectedType: undefined
          }
        }));
      };
    }, []);


    useEffect(() => {
      if (!_mapIns) return;
      _mapIns.on('click', methods.handleHide);
      _mapIns.on('movestart', methods.handleHide);
      _mapIns.on('zoomstart', methods.handleHide);
      return () => {
        _mapIns?.off?.('click', methods.handleHide);
        _mapIns?.off?.('movestart', methods.handleHide);
        _mapIns?.off?.('zoomstart', methods.handleHide);
      };
    }, [_mapIns]);

    const methods = useMethods({
      onClickBox() {
        if (trigger !== 'click') return;
        // 有二级退出菜单的工具箱功能开启时不允许点击工具箱
        if (targetOperation && !allowClickToolBoxList.includes(targetOperation)) {
          const targetOperationName = toolBoxList.find(item => item.key === targetOperation)?.name;
          V2Message.warning(`先退出新增${targetOperationName}`);
          return;
        };
        if (inDrawToolRef?.current) return; // 移入了绘制工具
        const curStatus = !isShowBox;
        setIsShowBox(curStatus);
        finallyShowStatus && finallyShowStatus(curStatus);
        // 测距和卫星关闭
        if (!isShowPanel && targetOperation && !allowClickToolBoxList.includes(targetOperation)) {
          closeOutPanel?.();
        }
        if (targetOperation === 'ruler' && isShowPanel) {
          setIsShowPanel(false);
          setRulerType(0);
          setIsCheckInsideMapOperate && setIsCheckInsideMapOperate(false);// 此时会关闭测距快捷面板，并设置测距类型为空，所以内部工具箱内部未被选中任何操作
        }
        bigdataFn('b4b658a6-c587-41b2-b52a-f20d30dd5699', '工具箱操作', '点击了工具箱操作', { op_block: '', op_event: ``, });
        onClickBoxHandle?.();
      },
      handleToolBoxEnter() {
        if (trigger !== 'hover') return;
        if (isShowPanel) return; // 显示测距快捷面板时，不显示
        if (inDrawToolRef?.current) return; // 移入了绘制工具
        inToolBoxRef.current = true;
        setIsShowBox(true);
        methods.handleHover(true);
        onToolBoxEnterHandle?.();
      },
      handleToolBoxLeave() {
        if (trigger !== 'hover') return;
        inToolBoxRef.current = false;
        setTimeout(() => {
          if (inDropDownBoxRef.current) return; // 移入了下拉框内
          if (isShowPanel) return; // 测距快捷面板在显示状态
          if (inDrawToolRef?.current) return; // 移入了绘制工具
          setIsShowBox(false);
          methods.handleHover(false);
        }, 200);
      },
      handleContentEnter: () => {
        if (trigger !== 'hover') return;
        inDropDownBoxRef.current = true;
      },
      handleContentLeave: () => {
        if (trigger !== 'hover') return;
        inDropDownBoxRef.current = false;
        setTimeout(() => {
          if (inToolBoxRef.current) return; // 移入了工具箱元素
          if (inDrawToolRef?.current) return; // 移入了绘制工具
          setIsShowBox(false);
        }, 200);
      },
      handleHover(curStatus) {
        finallyShowStatus && finallyShowStatus(curStatus);
        if (!isShowPanel) {
          closeOutPanel?.();
        }
        if (targetOperation === 'ruler' && isShowPanel) {
          setIsShowPanel(false);
          setRulerType(0);
          setIsCheckInsideMapOperate && setIsCheckInsideMapOperate(false);// 此时会关闭测距快捷面板，并设置测距类型为空，所以内部工具箱内部未被选中任何操作
        }
        if (targetOperation === 'checkInFieldA' && curStatus) {
          methods.quitFootPrint();
        }
      },
      /** 退出地图踩点 */
      quitFootPrint() {
        checkInFieldARef.current?.quitFootPrint?.();
        finallyShowStatus?.(false);
      },
      changeOperation(key:ToolBoxChangeOperationEnum, lngLat:LngLat) {
        console.log('key', key);
        switch (key) {
          case ToolBoxChangeOperationObj.RULER:
            rulerRef?.current?.handleClickRuler(1);
            break;
          case ToolBoxChangeOperationObj.CHECK_IN_FIELD_A:
            checkInFieldARef?.current?.handleFootPrint(lngLat);
            break;

          default:
            break;
        }
      },
      /**
           * @description 处理工具箱面板的显示
           */
      handleHide: () => {
        // 如果有选中则不处理
        if (targetOperation) return;
        // 否则关闭面板
        setIsShowBox(false);
        finallyShowStatus && finallyShowStatus(false);
      }
    });


    const getHeatMapConfig = () => {
      tenantCheck().then(({ heatMapFlag }) => {
        setHandleHeatMap(heatMapFlag);
      });
    };

    useEffect(() => {
      getHeatMapConfig();
    }, []);

    // 监测圈选、踩点、测距、标记，如果开启了功能，并再使用中，就进行回调toolChange
    // useEffect(() => {
    //   // window.rangingToolIsTurnOn = !!rulerType;
    //   const _ruler = !!rulerType;
    //   const _checkInFieldA = !!checkInFieldA && !isShowBox && mapView === MapView.City && targetOperation === 'checkInFieldA' && !!selected;
    //   // const _drawToolType = targetOperation === 'drawSearch' && !!drawToolType;

    //   // if (
    //   // toolChangeValueCache.current.ruler !== _ruler ||
    //   // toolChangeValueCache.current.checkInFieldA !== _checkInFieldA
    //   // toolChangeValueCache.current.dotMark !== _doMark ||
    //   // toolChangeValueCache.current.drawToolType !== _drawToolType
    //   // ) {
    //   // setToolOpen(_ruler || _footPrint || _doMark || _drawToolType);
    //   // }
    //   toolChange?.({
    //     ruler: _ruler,
    //     checkInFieldA: _checkInFieldA,
    //     // drawToolType: _drawToolType
    //   });
    //   if (
    //     toolChangeValueCache.current.ruler !== _ruler ||
    //     toolChangeValueCache.current.footPrint !== _footPrint ||
    //     toolChangeValueCache.current.dotMark !== _doMark ||
    //     // toolChangeValueCache.current.drawToolType !== _drawToolType
    //   ) {
    //     // setToolOpen(_ruler || _footPrint || _doMark || _drawToolType);
    //     toolChange?.({
    //       ruler: _ruler,
    //      checkInFieldA: _checkInFieldA
    //       dotMark: _doMark,
    //       drawToolType: _drawToolType
    //     });
    //   }
    // }, [rulerType, isShowBox, targetOperation, selected, mapView]);


    // 暴露相关方法
    useImperativeHandle(ref, () => ({
      handleSelected: setSelected,
      isShowBox: isShowBox,
      setIsShowBox: setIsShowBox,
      targetOperation: targetOperation, // 工具箱当前操作
      setTargetOperation: setTargetOperation, // 设置工具箱当前操作
      changeOperation: methods.changeOperation, // 切换工具箱操作
      finallyShowStatus: finallyShowStatus,
      clear() {
        getAddressRef.current?.clear(); // 关闭标记功能
        rulerRef.current?.clear(); // 关闭测距
        checkInFieldARef.current?.quitFootPrint(); // 退出打靶任务
      }
    }));

    return (
      <div className={styles.toolBoxCon}>
        <div
          className={
            cs(styles.toolBoxTitleCon,
              'bg-fff pointer selectNone mb-4',
              selected > 0 || isShowPanel ? 'c-132' : 'c-132')
          }
          style={{
            borderRadius: '4px',
            ...toolBoxWrapperStyle
          }}
          onClick={methods.onClickBox}
          onMouseEnter={() => methods.handleToolBoxEnter()}
          onMouseLeave={() => methods.handleToolBoxLeave()}
        >
          {
            beforeIcon || <IconFont
              iconHref='iconic_toolbox'
              style={{ width: '14px', height: '14px' }} />
          }
          <span className={cs(styles.title, 'ml-5 mr-8 c-222 fs-14', 'tool-box-title')}>工具箱</span>
          {
            afterIcon ? (isFunction(afterIcon) ? afterIcon(isShowBox) : afterIcon) : (isShowBox ? <IconFont
              iconHref={'iconic_zhankai_seven'}
              className='fs-12 c-959'
            /> : <IconFont
              iconHref='iconarrow-down'
              className='fs-12 c-959'
            />)
          }
          {/* <span className={styles.iconArrow}>
            <CaretDownOutlined />
          </span> */}

        </div>

        {/* 测距工具面板  工具箱打开的时候不显示*/}
        {isShowPanel &&
        <RulerShortCutPanel
          rulerType={rulerType}
          setRulerType={setRulerType}
          setIsShowPanel={setIsShowPanel}
          rulering={rulering}
          setIsCheckInsideMapOperate={setIsCheckInsideMapOperate}
          floatDirection={floatDirection}
          finallyShowStatus={finallyShowStatus}
          setTargetOperation={setTargetOperation}
        />}

        {!!checkInFieldA && !isShowBox && mapView === MapView.City && targetOperation === 'checkInFieldA' && !!selected && <QuitFootPrint
          style={contentStyle}
          quitFootPrint={() => methods.quitFootPrint()} targetPunchInAlias={targetPunchInAlias}/>}


        {/* 工具箱内容 */}
        <div
          className={styles.panelContent}
          style={panelContentStyleOfOut}
          onMouseEnter={() => methods.handleContentEnter()}
          onMouseLeave={() => methods.handleContentLeave()}
        >
          {/* {isShowBox && <div className={styles.triangle}></div>} */}
          <div
            className={styles.content}
            style={{
              display: isShowBox ? 'block' : 'none'
            }}
          >
            <div>
              {/* 标记 */}
              {getAddress && <GetAddress
                ref={getAddressRef}
                clearClickEvent={clearClickEvent}
                addClickEvent={addClickEvent}
                _mapIns={_mapIns}
                URLParamsRef={URLParamsRef}
                targetOperation={targetOperation}
                setTargetOperation={setTargetOperation}
                setSelected={setSelected}
                // isCheckInsideMapOperate={isCheckInsideMapOperate}
                isCheckOutsideMapOperate={isCheckOutsideMapOperate}
                setIsCheckInsideMapOperate={setIsCheckInsideMapOperate}
                setIsCheckOutsideMapOperate={setIsCheckOutsideMapOperate}
                getAddressEventId={getAddressEventId}
                style={contentStyle}
              />}
              {/* 测距 */}
              {ruler && <Ruler
                clearClickEvent={clearClickEvent}
                addClickEvent={addClickEvent}
                _mapIns={_mapIns}
                setSelected={setSelected}
                setIsShowBox={setIsShowBox}
                rulering={rulering}
                setRulering={setRulering}
                rulerType={rulerType}
                setRulerType={setRulerType}
                setIsShowPanel={setIsShowPanel}
                targetOperation={targetOperation}
                setTargetOperation={setTargetOperation}
                // isCheckInsideMapOperate={isCheckInsideMapOperate}
                isCheckOutsideMapOperate={isCheckOutsideMapOperate}
                setIsCheckInsideMapOperate={setIsCheckInsideMapOperate}
                setIsCheckOutsideMapOperate={setIsCheckOutsideMapOperate}
                rulerEventId={rulerEventId}
                style={contentStyle}
                trigger={trigger}
                floatDirection={floatDirection}
                isAutoFitView={isAutoFitView}
                ref={rulerRef}
              />}
              {/* 卫星 */}
              {satellite && <Satellite
                _mapIns={_mapIns}
                URLParamsRef={URLParamsRef}
                setSelected={setSelected}
                style={contentStyle}
                satelliteEventId={satelliteEventId}
                setTargetOperation={setTargetOperation}
              />}
              {/* 分享 */}
              {share && <Share
                _mapIns={_mapIns}
                URLParamsRef={URLParamsRef}
                setSelected={setSelected}
              />}
              {/* 说明文档 */}
              {explain && <Explain/>}
              {/* 热力图 */}
              {heartMap && handleHeatMap && <HeatMapTool
                _mapIns={_mapIns}
                setSelected={setSelected}
                externalStatus={externalStatus}
                extraCityInfo={extraCityInfo}
                // isShowInCountry={isShowInCountry} // 是否在全国状态下显示热力图
                needPermission={needHeatMapPermission}
                setIsOpenHeatMap={setIsOpenHeatMap}
                topLevel={topLevel}
              />}
              {/* 新增打靶任务 */}
              {checkInFieldA && <CheckInFieldA
                ref={checkInFieldARef}
                _mapIns={_mapIns}
                mapView={mapView}
                clearClickEvent={clearClickEvent}
                addClickEvent={addClickEvent}
                URLParamsRef={URLParamsRef}
                targetOperation={targetOperation}
                setTargetOperation={setTargetOperation}
                setSelected={setSelected}
                isCheckOutsideMapOperate={isCheckOutsideMapOperate}
                setIsCheckInsideMapOperate={setIsCheckInsideMapOperate}
                setIsCheckOutsideMapOperate={setIsCheckOutsideMapOperate}
                style={contentStyle}
                isFull={isFull}
                // showFootPrint={showFootPrint}
                // setShowFootPrint={setShowFootPrint}
                setIsShowBox={setIsShowBox}
                // toolOpen={toolOpen}
                targetPunchInAlias={targetPunchInAlias}
                onRefreshCheckInData={onRefreshCheckInData}
              />}
            </div>
            {children}
          </div>
        </div>

      </div>
    );
  });

export default ToolBox;
